import styled from 'styled-components';

const Gif = styled.img`
  max-width: 100%;
`;

export default Gif;
